import { createSlice } from '@reduxjs/toolkit';
import { setToStore } from '../pages/Utils/fn';
import constants from '../pages/Utils/constants.json';

const initialState = {
  data: null, // { mainLocation: string, locationName: string }
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLocation: (state, action) => {
      state.data = action.payload;
      setToStore(constants.CURRENT_LOCATION, action.payload);
    },
    clearLocation: (state) => {
      state.data = null;
    },
  },
});

export const { setLocation, clearLocation } = locationSlice.actions;
export default locationSlice.reducer;
